import { render, staticRenderFns } from "./RoundsOfRewards.vue?vue&type=template&id=1b9e6e13&scoped=true&"
import script from "./RoundsOfRewards.vue?vue&type=script&lang=js&"
export * from "./RoundsOfRewards.vue?vue&type=script&lang=js&"
import style0 from "./RoundsOfRewards.vue?vue&type=style&index=0&id=1b9e6e13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e6e13",
  null
  
)

export default component.exports